'use strict';

export default [
  {
    guideId: 9504195,
    vimeoId: 145137910,
    heading: 'Adventures with Julia in&nbsp;Kiev',
    cover: require('../../images/intro_video/julia.jpg'),
    coverMobile: require('../../images/intro_video/julia_mobile.jpg'),
    coverSquare: require('../../images/intro_video/julia_square.jpg'),
    thumb: require('../../images/intro_video/julia_thumb.jpg'),
    type: 'video',
    name: 'Julia',
    locationName: 'Kiev, Ukraine',
    placeId: 'ChIJBUVa4U7P1EAR_kYBF9IxSXY'
  },
  {
    guideId: 9506277,
    vimeoId: 144345301,
    heading: 'So you say you know&nbsp;Berlin?',
    cover: require('../../images/intro_video/matts.jpg'),
    coverMobile: require('../../images/intro_video/matts_mobile.jpg'),
    coverSquare: require('../../images/intro_video/matts_square.jpg'),
    thumb: require('../../images/intro_video/matts_thumb.jpg'),
    type: 'video',
    name: 'Matts',
    locationName: 'Berlin, Germany',
    placeId: 'ChIJAVkDPzdOqEcRcDteW0YgIQQ'
  },
  {
    guideId: 9506244,
    vimeoId: 145844830,
    heading: 'In Berlin, sleep is&nbsp;commercial',
    cover: require('../../images/intro_video/sara.jpg'),
    coverMobile: require('../../images/intro_video/sara_mobile.jpg'),
    coverSquare: require('../../images/intro_video/sara_square.jpg'),
    thumb: require('../../images/intro_video/sara_thumb.jpg'),
    type: 'video',
    name: 'Sara',
    locationName: 'Berlin, Germany',
    placeId: 'ChIJAVkDPzdOqEcRcDteW0YgIQQ'
  },
  {
    guideId: 9504672,
    vimeoId: 146671085,
    heading: 'No other city like Amsterdam',
    cover: require('../../images/intro_video/jasmijn.jpg'),
    coverMobile: require('../../images/intro_video/jasmijn_mobile.jpg'),
    coverSquare: require('../../images/intro_video/jasmijn_square.jpg'),
    thumb: require('../../images/intro_video/jasmijn_thumb.jpg'),
    type: 'video',
    name: 'Jasmijn',
    locationName: 'Amsterdam, Netherlands',
    placeId: 'ChIJVXealLU_xkcRja_At0z9AGY'
  },
  {
    guideId: 9506733,
    vimeoId: 147345898,
    heading: 'Secret walks of the old Kiev',
    cover: require('../../images/intro_video/ksenia.jpg'),
    coverMobile: require('../../images/intro_video/ksenia_mobile.jpg'),
    coverSquare: require('../../images/intro_video/ksenia_square.jpg'),
    thumb: require('../../images/intro_video/ksenia_thumb.jpg'),
    type: 'video',
    name: 'Ksenia',
    locationName: 'Kiev, Ukraine',
    placeId: 'ChIJBUVa4U7P1EAR_kYBF9IxSXY'
  },
  {
    guideId: 9506308,
    vimeoId: 149543853,
    heading: 'A brief party-goer’s guide',
    cover: require('../../images/intro_video/elizabeth.jpg'),
    coverMobile: require('../../images/intro_video/elizabeth_mobile.jpg'),
    coverSquare: require('../../images/intro_video/elizabeth_square.jpg'),
    thumb: require('../../images/intro_video/elizabeth_thumb.jpg'),
    type: 'video',
    name: 'Elizabeth',
    locationName: 'Kiev, Ukraine',
    placeId: 'ChIJBUVa4U7P1EAR_kYBF9IxSXY'
  },
  {
    guideId: 9502890,
    vimeoId: 148611653,
    heading: 'The sinful spots of Hamburg',
    cover: require('../../images/intro_video/marina.jpg'),
    coverMobile: require('../../images/intro_video/marina_mobile.jpg'),
    coverSquare: require('../../images/intro_video/marina_square.jpg'),
    thumb: require('../../images/intro_video/marina_thumb.jpg'),
    type: 'video',
    name: 'Marina',
    locationName: 'Hamburg, Germany',
    placeId: 'ChIJuRMYfoNhsUcRoDrWe_I9JgQ'
  },
  {
    guideId: 9506297,
    vimeoId: 186268101,
    heading: 'City Tour with Dan in Berlin',
    cover: require('../../images/intro_video/tour_berlin/dan.jpg'),
    coverMobile: require('../../images/intro_video/tour_berlin/dan_mobile.jpg'),
    coverSquare: require('../../images/intro_video/tour_berlin/dan_square.jpg'),
    thumb: require('../../images/intro_video/tour_berlin/dan_thumb.jpg'),
    type: 'video',
    name: 'Dan',
    locationName: 'Berlin, Germany',
    placeId: 'ChIJAVkDPzdOqEcRcDteW0YgIQQ'
  },
  {
    guideId: 9503659,
    vimeoId: 160114000,
    heading: 'Istanbul: A mix of East and West',
    cover: require('../../images/intro_video/ayse.jpg'),
    coverMobile: require('../../images/intro_video/ayse_mobile.jpg'),
    coverSquare: require('../../images/intro_video/ayse_square.jpg'),
    thumb: require('../../images/intro_video/ayse_thumb.jpg'),
    type: 'video',
    name: 'Ayse',
    locationName: 'Istanbul, Turkey',
    placeId: 'ChIJawhoAASnyhQR0LABvJj-zOE'
  },
  {
    guideId: 9608663,
    vimeoId: 200683666,
    heading: 'Nothing stops Detroit',
    cover: require('../../images/intro_video/nothing_stops_detroit/detroit.jpg'),
    coverMobile: require('../../images/intro_video/nothing_stops_detroit/detroit_mobile.jpg'),
    coverSquare: require('../../images/intro_video/nothing_stops_detroit/detroit_square.jpg'),
    thumb: require('../../images/intro_video/nothing_stops_detroit/detroit_thumb.jpg'),
    type: 'video',
    name: 'Lisa and Bill',
    locationName: 'Detroit, United States',
    placeId: 'ChIJdR3LEAHKJIgR0sS5NU6Gdlc'
  },
  {
    guideId: 9608779,
    vimeoId: 189922833,
    heading: 'The famed Cuban neighbourhood',
    cover: require('../../images/intro_video/cuban_neighbourhood/susan.jpg'),
    coverMobile: require('../../images/intro_video/cuban_neighbourhood/susan_mobile.jpg'),
    coverSquare: require('../../images/intro_video/cuban_neighbourhood/susan_square.jpg'),
    thumb: require('../../images/intro_video/cuban_neighbourhood/susan_thumb.jpg'),
    type: 'video',
    name: 'Susan',
    locationName: 'Miami, United States',
    placeId: 'ChIJEcHIDqKw2YgRZU-t3XHylv8'
  }
];



// WEBPACK FOOTER //
// ./app/src/constants/videos.js